import React from 'react';
import popup from '../images/popup.png';
import popup_alt from '../images/popup2.png';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const Popup = (props) => {
    const popup_src = props.popup === 2 ? popup_alt : popup;
    return (
        
        <div className="popup" style={{ width: props.width }}>
            <img src={popup_src} alt={"Mac OS styled popup"} />
            <div className='inner-popup'>
                <h2>Concept Art</h2>
                <Zoom>
                <img src={props.image} alt={"Concept art; kiki's delivery service meets roblox"} />
                </Zoom>
            </div>
        </div>
    );
};

export default Popup;